var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BasicSingleVideo',{attrs:{"title":_vm.title,"videosrc":_vm.videosrc,"videoposter":_vm.videoposter,"videopostermob":_vm.videopostermob,"videofullsrc":_vm.videofullsrc,"maidiansuffix":_vm.maidiansuffix}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }